export default __webpack_public_path__ + "static/media/workout-1.6e440582.jpg";